module.exports = __webpack_public_path__ + "static/img/2.2adb3f3f.png";